'use client';
import { withAuthenticationRequired } from '@/auth';
import { FullPageLoader } from '@/components/full-page-loader/full-page-loader';
import dynamic from 'next/dynamic';
const CreateExperience = dynamic(() => import('../components/my-experience/create'), {
  ssr: false,
});

const AuthCreateExperiencePage = withAuthenticationRequired(CreateExperience, {
  onRedirecting: () => <FullPageLoader>Redirecting to login page...</FullPageLoader>,
});

export default AuthCreateExperiencePage as any;
